import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetOneIpWhitelist } from './getOneIpWhitelist';
export const DependencyInjectioIpsInfrastructure = () => {
    container.register("IGetOneIpWhitelist", { useClass: GetOneIpWhitelist });
};
export default DependencyInjectioIpsInfrastructure;
